<input matInput [matAutocomplete]="searchAuto" [formControl]="searchControl" placeholder="Hae">
<mat-autocomplete autoActiveFirstOption #searchAuto="matAutocomplete" [displayWith]="displayFn"
                  (optionSelected)="handleSelect($event)">
  <mat-option *ngFor="let result of searchResults | async" [value]="result">
    {{ result.displayName }}
  </mat-option>
</mat-autocomplete>
